import { render, staticRenderFns } from "./larval_identification.vue?vue&type=template&id=383d3839&"
import script from "./larval_identification.vue?vue&type=script&lang=js&"
export * from "./larval_identification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports